import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { FRAGMENT_CUSTOM_FORMAT_GROUP } from 'src/graphql/format/schema';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation SetBrandVoiceCustomFormatGroupDefaults(
    $brandVoiceId: ID!
    $customFormatGroupId: ID!
    $on: Boolean!
  ) {
    setBrandVoiceCustomFormatGroupDefaults(
      customFormatGroupId: $customFormatGroupId
      brandVoiceId: $brandVoiceId
      on: $on
    ) {
      group {
        ...CustomFormatGroup
      }
      on
    }
  }
  ${FRAGMENT_CUSTOM_FORMAT_GROUP}
`;

interface MutationParams {
  brandVoiceId: ID;
  formatGroupId: ID;
  on: boolean;
}

interface MutationResult {
  id: ID;
}

export const setCustomFormatGroupDefaults = async ({
  brandVoiceId,
  formatGroupId,
  on,
}: MutationParams) => {
  const variables = {
    brandVoiceId,
    customFormatGroupId: formatGroupId,
    on,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<MutationResult>(result.data);
};
